var path = '/app-lite/grids/templates/cell.time-picker.html';
var html = "<div data-ng-show=\"editable\">\n  <a href=\"javascript:void(0)\" class=\"input-group-addon date-time\"\n    data-ng-click=\"openPicker(row, col, $event)\">\n    <i class=\"fa fa-clock-o\"></i>\n  </a>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;